import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { useAuthMutation } from "./useAuthMutation"

export function useRefreshTokenMutation(config = {}) {
    const url = "token/refresh/"
    return useAuthMutation(url, axiosInstance.post, {}, config)
}
